<!-- PAGE TITLE
        ================================================== -->
<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>ADMISSION OFFICES</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="#!">Admission</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>


<section>
    <div class="container">
        <table class="table table-responsive table-bordered text-center">
            <thead style="background-color: #e67e22;color: white;">
            <tr>
                <th class="bg-secondary text-white" width="200px"> Centre Name</th>
                <th class="bg-secondary text-white"> Office Address</th>
                <th class="bg-secondary text-white"> Contact Person</th>
                <th class="bg-secondary text-white"> Contact No</th>
                <th class="bg-secondary text-white"> State</th>
            </tr>
            </thead>
            <tbody style="background: aliceblue;color:black font-weight: bold;">
            <tr>
                <td> Pathankot</td>
                <td> Saili Road Near Axis Bank</td>
                <td>Mr. Ashish Prasher</td>
                <td> 62-8317-5985 / 97-7989-1874</td>
                <td> Punjab</td>
            </tr>
            <tr>
                <td> Mukerian</td>
                <td> Apple Computer Center Near Mata Rani Chowk</td>
                <td>Mr. Harjit Singh / Mr. Bhupinder Singh</td>
                <td> 75-8900-0551 / 98-8861-9901</td>
                <td> Punjab</td>
            </tr>
            <tr>
                <td> Talwara</td>
                <td> Nirmala Complex, Choudhary Gian Chand Chowk Old Bus Stand</td>
                <td>Mr. Ashish Sharma / Mr. Rajinder Singh</td>
                <td> 98-1618-8007 / 96-4621-8776</td>
                <td> Punjab</td>
            </tr>
            <tr>
                <td> Kathua</td>
                <td> Magnification Tutorials Near Kalibari Chowk Kathua(J&amp;K)</td>
                <td>Mr. Akhil Sharma</td>
                <td> 87-1604-4440</td>
                <td> J&amp;K</td>
            </tr>
            <tr>
                <td> Sujanpur</td>
                <td> Opposite Neena Complex Near Patanjali Store</td>
                <td> Mr. Aseem Kumar</td>
                <td> 93-1760-1158 / 82-8495-5161</td>
                <td> Himachal Pradesh</td>
            </tr>
            <tr>
                <td> Nurpur</td>
                <td> Chogan Bazar Near Bus Stand</td>
                <td> Mr. Rachit</td>
                <td> 86-2693-7316 / 93-1709-7816</td>
                <td> Himachal Pradesh</td>
            </tr>

            <tr>
                <td> Jawali</td>
                <td> Kehrian Chowk, Jawali. Distt. Kangra</td>
                <td> Mr. Ankush uppal / Mr. Ankush Sharma</td>
                <td> 98-1528-3776 / 98-7759-3328</td>
                <td> Himachal Pradesh</td>
            </tr>

            <tr>
                <td> Chamba</td>
                <td> Sultanpur, Near Degree College</td>
                <td> Mr. Yash Pal</td>
                <td> 82-1951-7497</td>
                <td> Himachal Pradesh</td>
            </tr>

            <tr>
                <td> Samba</td>
                <td> Opposite Govt. Degree College Ghagwal</td>
                <td> Mr. Rohit Kumar</td>
                <td> 78-8976-5638</td>
                <td> Himachal Pradesh</td>
            </tr>

            </tbody>
        </table>
    </div>
</section>
